import { FilterElementType } from "@utils/DynamicComponentUtils";
import { exposureStatusCheck, textFormat, upDataAtFormat } from "@utils/TableItemFormattingUtils";
import { type ColDef } from "ag-grid-community";
import { type CommonFilterDataType, type CommonFormType } from "src/types/common";

export type FaqInitialValues = {
    keyword?: string;
    isVisible?: string;
    mainCategory?: string;
    middleCategory?: string;
};

export type FaqFormType = {
    className?: string;
} & CommonFormType;

export const faqData: CommonFilterDataType<FaqInitialValues, FaqFormType, ColDef> = {
    formInitialValues: {
        mainCategory: "",
        middleCategory: "",
        keyword: "",
        isVisible: "",
    },
    forms: [
        {
            type: FilterElementType.INPUT,
            name: "keyword",
            label: "제목+본문",
        },
        {
            type: FilterElementType.SELECT,
            name: "isVisible",
            label: "노출 상태",
            option: [
                {
                    label: "전체",
                    value: "",
                },
                {
                    label: "노출",
                    value: "true",
                },
                {
                    label: "미노출",
                    value: "false",
                },
            ],
        },
    ],
    tableList: [
        {
            field: "rowNumber",
            headerName: "순번",
            maxWidth: 120,
            minWidth: 100,
            flex: 1,
            suppressMovable: true,
            cellRenderer: textFormat,
        },
        {
            field: "isVisible",
            headerName: "노출 상태",
            maxWidth: 120,
            minWidth: 100,
            flex: 1,
            suppressMovable: true,
            cellRenderer: exposureStatusCheck,
        },
        {
            field: "mainCategoryDescription",
            headerName: "대분류",
            maxWidth: 120,
            minWidth: 100,
            flex: 1,
            suppressMovable: true,
            cellRenderer: textFormat,
        },
        {
            field: "middleCategoryDescription",
            headerName: "중분류",
            maxWidth: 120,
            minWidth: 110,
            flex: 1,
            suppressMovable: true,
            cellRenderer: textFormat,
        },
        {
            field: "title",
            headerName: "제목",
            minWidth: 100,
            flex: 1,
            suppressMovable: true,
            cellRenderer: textFormat,
        },
        {
            field: "updatedAt",
            headerName: "업데이트 일시",
            minWidth: 180,
            maxWidth: 200,
            flex: 1,
            suppressMovable: true,
            cellRenderer: upDataAtFormat,
        },
        {
            field: "updatedBy",
            headerName: "마지막 수정",
            pinned: "right",
            minWidth: 100,
            maxWidth: 120,
            suppressMovable: true,
            cellRenderer: textFormat,
        },
    ],
};
